import React from 'react';

import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import PagesIcon from '@material-ui/icons/Pages';

import {
  PERMISSAO_TELA_NFCES_LISTAR,
  PERMISSAO_TELA_NFES_LISTAR,
  PERMISSAO_TELA_INDICADORES_NFCE_LISTAR,
  PERMISSAO_TELA_INDICADORES_NFE_LISTAR,
  PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR,
  PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuFiscal = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Fiscal"
    icon={<PagesIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR] && (
      <StyledMenuItemLink
        key="indicadores-fiscais"
        to="/indicadores-fiscais"
        primaryText="Dashboard"
        leftIcon={<DashboardIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_NFCES_LISTAR] && hasResource('fiscal_nfces')}
    {permissoes[PERMISSAO_TELA_NFES_LISTAR] && hasResource('fiscal_nfes')}
    {permissoes[PERMISSAO_TELA_INDICADORES_NFCE_LISTAR] && (
      <StyledMenuItemLink
        key="indicadores-nfce"
        to="/indicadores-nfce"
        primaryText="Indicadores Nfce"
        leftIcon={<ImportExportIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_INDICADORES_NFE_LISTAR] && (
      <StyledMenuItemLink
        key="indicadores-nfe"
        to="/indicadores-nfe"
        primaryText="Indicadores Nfe"
        leftIcon={<ImportExportIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR] &&
      hasResource('relatorios_fiscais_execucoes')}
    {permissoes[PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorios-fiscais-acompanhamento"
        to="/relatorios-fiscais/acompanhamento"
        primaryText="Acompanhamento do Mês"
        leftIcon={<CalendarTodayIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
  </SubMenu>
);

export default SubMenuFiscal;
